import React from 'react';
import { Segment } from 'semantic-ui-react';
//noinspection NpmUsedModulesInstalled
import { SidebarPortal } from '@plone/volto/components';
//noinspection NpmUsedModulesInstalled
import { withBlockExtensions } from '@plone/volto/helpers';
import DownloadBlockDataForm from './DownloadBlockDataForm';
import DownloadItems from './DownloadItems';
import './static/style/block.less';
import './static/style/modal.less';

const Edit = (props) => {
  const { data, onChangeBlock, block, selected } = props;

  return (
    <>
      <DownloadItems data={data} id={block} isEditMode />
      <SidebarPortal selected={selected}>
        <Segment.Group raised>
          <header className="header pulled">
            <h2>Download</h2>
          </header>

          <DownloadBlockDataForm key={block} {...props} data={data} block={block} onChangeBlock={onChangeBlock} />
        </Segment.Group>
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(Edit);
